import { s3Instance } from '@/services';
import { FileUtils } from '@/helpers';
import Vue from 'vue';

export default Vue.extend({
  methods: {
    /**
     * @param File[] files.
     * @return object mapping filename to S3 key
     */
    uploadFiles(files): Promise<any> {
      const UPLOAD_PROMISES = [];
      const NEW_S3_KEYS = {};
      files.forEach((file) => {
        const EXTENSION = FileUtils.getFilenameExtension(file.name);
        const PUT_FILE_PROMISE = s3Instance
          .putFile(file, EXTENSION)
          .then((s3Key) => {
            NEW_S3_KEYS[file.name] = s3Key;
          });
        UPLOAD_PROMISES.push(PUT_FILE_PROMISE);
      });

      return Promise.all(UPLOAD_PROMISES).then(() => NEW_S3_KEYS);
    },
  },
});
